// extracted by mini-css-extract-plugin
export default {"nutrients":"MealList_nutrients__ex8oa"};